import { useState } from 'react';

const galleryImages = [
  {
    id: 1,
    url: "/images/IMG_1649.jpg",
    alt: "Taller MV Auto Expert"
  },
  {
    id: 2,
    url: "/images/IMG_1711.jpg",
    alt: "Trabajo en transmisión"
  },
  {
    id: 3,
    url: "/images/IMG_1712.jpg",
    alt: "Interior del taller"
  },
  {
    id: 4,
    url: "/images/IMG_1812.jpg",
    alt: "Servicio de llantas"
  },
  {
    id: 5,
    url: "/images/IMG_1727.jpg",
    alt: "Servicio profesional"
  },
  {
    id: 6,
    url: "/images/IMG_1730.jpg",
    alt: "Reparación especializada"
  },
  {
    id: 7,
    url: "/images/IMG_1751.jpg",
    alt: "Equipo de trabajo"
  },
  {
    id: 8,
    url: "/images/IMG_1756.jpg",
    alt: "Instalaciones del taller"
  },
  {
    id: 9,
    url: "/images/IMG_1675.jpg",
    alt: "Servicio de calidad"
  },
];

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section 
      id="gallery" 
      className="py-20 md:py-32 bg-zinc-950"
      data-testid="gallery-section"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span 
            className="text-xs font-bold uppercase tracking-[0.2em] text-yellow-400 mb-4 block"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
          >
            Nuestro Trabajo
          </span>
          <h2 
            className="text-4xl sm:text-5xl font-bold uppercase tracking-tight text-white"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
            data-testid="gallery-title"
          >
            Galería
          </h2>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
          {galleryImages.map((image) => (
            <div
              key={image.id}
              className="relative aspect-square overflow-hidden cursor-pointer group"
              onClick={() => setSelectedImage(image)}
              data-testid={`gallery-image-${image.id}`}
            >
              <img 
                src={image.url} 
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-blue-600/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              
              {/* Zoom Icon */}
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="w-12 h-12 bg-blue-600 flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div 
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
          data-testid="gallery-lightbox"
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-6 right-6 text-white hover:text-yellow-400 transition-colors"
            data-testid="close-lightbox"
          >
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <img 
            src={selectedImage.url} 
            alt={selectedImage.alt}
            className="max-w-full max-h-[85vh] object-contain"
          />
        </div>
      )}
    </section>
  );
};

export default GallerySection;
